<template>
    <div
            class="day-select"
            :class="{
                'day-select_small': small
            }"
    >
        <v-btn
                icon
                class="day-select__btn"
                @click="prevDay"
                elevation="0"
        >
            <v-icon class="day-select__arrow-back">mdi-play</v-icon>
        </v-btn>
        <v-menu
                v-model="modelMenu"
                :close-on-content-click="false"
                bottom
                offset-y
        >
            <template v-slot:activator="{on}">
                <div
                        class="day-select__date"
                        v-on="on"
                >
                    <template v-if="showWeekDay">{{ $t('week.'+getDayWeek) }}, </template>
                    <template v-if="shortMonth">
                        <template v-if="showYear">{{ getDay }} {{ $t('monthShort.'+getMonth) }} {{ getYear }}</template>
                        <template v-else>{{ getDay }} {{ $t('monthShort.'+getMonth) }}</template>
                    </template>
                    <template v-else>
                        <template v-if="showYear">{{ getDay }} {{ $t('monthNameNum.'+getMonth) }} {{ getYear }}</template>
                        <template v-else>{{ getDay }} {{ $t('monthNameNum.'+getMonth) }}</template>
                    </template>
                </div>
            </template>
            <v-card class="day-select__picker">
                <v-date-picker
                        :value="getDate"
                        @input="setDate($event)"
                        :locale="$store.getters.lang"
                        first-day-of-week="1"
                ></v-date-picker>
                <div class="d-flex justify-end pa-3">
                    <v-btn
                            color="primary"
                            @click="cancel()"
                            class="mr-3"
                            elevation="0"
                    >{{ $t('msg.cancel') }}</v-btn>
                    <v-btn
                            color="primary"
                            @click="apply()"
                            elevation="0"
                    >{{ $t('msg.apply') }}</v-btn>
                </div>
            </v-card>
        </v-menu>
        <v-btn
                icon
                class="day-select__btn"
                @click="nextDay"
                elevation="0"
        >
            <v-icon>mdi-play</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import {parse, format, addDays} from 'date-fns';

    export default {
        props: {
            value: {type: Date, default: null},
            showWeekDay: {type: Boolean, default: true},
            shortMonth: {type: Boolean, default: false},
            showYear: {type: Boolean, default: true},
            small: {type: Boolean, default: false}
        },
        data() {
            return {
                localValue: this.value,
                localValuePicker: this.value,
                modelMenu: false
            }
        },
        computed: {
            getDay() {
                return format(this.localValue, 'd');
            },
            getYear() {
                return format(this.localValue, 'yyyy');
            },
            getMonth() {
                return format(this.localValue, 'MMMM');
            },
            getDayWeek() {
                return format(this.localValue, 'EEEE');
            },
            getDate() {
                return format(this.localValuePicker, 'yyyy-MM-dd');
            }
        },
        watch: {
            value(v) {
                this.localValue = v;
            },
            modelMenu(v, oldV) {
                if (!v && oldV) {
                    this.cancel();
                }
            }
        },
        methods: {
            setDate(v) {
                this.localValuePicker = parse(v, 'yyyy-MM-dd', new Date());
            },
            nextDay() {
                this.localValue = addDays(this.localValue, 1);
                this.localValuePicker = this.localValue;
                this.$emit('input', this.localValue);
            },
            prevDay() {
                this.localValue = addDays(this.localValue, -1);
                this.localValuePicker = this.localValue;
                this.$emit('input', this.localValue);
            },
            cancel() {
                this.localValuePicker = this.localValue;
                this.modelMenu = false;
            },
            apply() {
                this.localValue = this.localValuePicker;
                this.$emit('input', this.localValue);
                this.modelMenu = false;
            }
        }
    }
</script>

<style lang="scss">
    .day-select {
        display: flex;
        align-items: center;

        &.day-select_small {
            .day-select__btn {
                width: 20px;
                height: 20px;
                margin: 0;

                .v-icon {
                    font-size: 18px;
                }
            }
        }
    }
    .day-select__arrow-back {
        transform: rotate(180deg);
    }
    .day-select__date {
        padding-top: 3px;
        user-select: none;
    }
    .day-select__btn {
        margin: 0 5px;
    }
    .day-select__date {
        cursor: pointer;
    }
    .day-select__picker {
        .v-picker {
            box-shadow: none;
        }
        .v-date-picker-table {
            height: inherit !important;
        }
    }
</style>